import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
export var CalendarType = {
  GOOGLE: 1,
  OUTLOOK: 2
};

var CalendarEvent = /*#__PURE__*/function (_Shareable) {
  _inherits(CalendarEvent, _Shareable);

  var _super = _createSuper(CalendarEvent);

  function CalendarEvent() {
    _classCallCheck(this, CalendarEvent);

    return _super.apply(this, arguments);
  }

  _createClass(CalendarEvent, null, [{
    key: "fromPlainObject",
    value: function fromPlainObject(obj) {
      if (!obj) {
        return new NullCalendarEvent();
      }

      var id = obj.id,
          calendarType = obj.calendarType,
          calendarID = obj.calendarID;
      var calendarEvent = new this();
      calendarEvent.id = id;
      calendarEvent.calendarType = calendarType;
      calendarEvent.calendarID = calendarID;
      return calendarEvent;
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['id', 'calendarType', 'calendarID'];
    }
  }]);

  return CalendarEvent;
}(Shareable);

export { CalendarEvent as default };
export var NullCalendarEvent = /*#__PURE__*/function (_CalendarEvent) {
  _inherits(NullCalendarEvent, _CalendarEvent);

  var _super2 = _createSuper(NullCalendarEvent);

  function NullCalendarEvent() {
    _classCallCheck(this, NullCalendarEvent);

    return _super2.apply(this, arguments);
  }

  _createClass(NullCalendarEvent, [{
    key: "isNull",
    value: function isNull() {
      return true;
    }
  }]);

  return NullCalendarEvent;
}(CalendarEvent);